// extracted by mini-css-extract-plugin
module.exports = {"testTop":"TestMode_testTop__0jA_f","testBox":"TestMode_testBox__G52_N","testHeader":"TestMode_testHeader__4_w_i","grid":"TestMode_grid__AD1YV"};